const OWNED_BOT_ID = /^[1-9]\d{0,18}$/;

export const normalizeBacktestBotId = (value) => {
  const candidate = String(value ?? '').trim();
  return OWNED_BOT_ID.test(candidate) ? candidate : '';
};

export const backtestHandoffPath = (botId) => {
  const normalized = normalizeBacktestBotId(botId);
  return normalized ? `/backtests?bot_id=${encodeURIComponent(normalized)}` : '/backtests';
};

export const ownedPreselectedBacktestBotId = (requestedBotId, bots = []) => {
  const normalized = normalizeBacktestBotId(requestedBotId);
  if (!normalized) return '';
  return bots.some((bot) => String(bot?.id) === normalized) ? normalized : '';
};
